import { HttpClient } from '../httpClient';
import StudentUpdateRequest from '../requests/studentUpdateRequest';
import StudentRequest from '../requests/studentRequest';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import StudentsResponse from '../responses/studentsResponse';
import StudentResponse from '../responses/studentResponse';
//import StudentTreatmentRequest from '../requests/StudentTreatmentRequest';
import studentTreamentResponse from '../responses/studentTreatmentsResponse';
import Caseload from '../models/caseload';
import StudentOption from '../models/studentOption';
import StudentDiscipline from '../models/studentdiscipline';
import StudentDuplicatesResponse from '../responses/studentDuplicatesResponse';
import MergeStudentsRequest from '../requests/mergeStudentsRequest';
import StudentSchoolHistory from '../models/studentSchoolHistory';
import StudentCustomMergRequest from '../requests/studentCustomMergRequest';
import StudentMergeResponse from '../responses/studentMergeResponse';
//import StudentTreatment from '../models/studentTreatment';


const httpClient = new HttpClient();

export const createStudent = async (studentrequest: StudentRequest) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/students',
    payload: studentrequest,
    requiresToken: true,
  });
};

export const mergeStudents = async (mergeStudentRequest: MergeStudentsRequest) => {
    return httpClient.post<DataResponse<any>>({
    url: '/v1/students/Merge',
    payload: mergeStudentRequest,
    requiresToken: true,
  });
};

export const getStudents = async (
  disciplineId: number,
  firstName: string,
  lastName: string,
  dob: string
) => {
  return httpClient.get<StudentsResponse>({
    url: `/v1/students/with-caseload?disciplineId=${disciplineId}&firstName=${firstName}&lastName=${lastName}&dob=${dob}`,
    requiresToken: true,
  });
};

export const getAllStudents = async ( 
  firstName?: string,
  lastName?: string,
  dob?: string
) => {
  return httpClient.get<StudentsResponse>({
    url: `/v1/students?firstName=&lastName=&dob=`,
    requiresToken: true,
  });
};

export const getStudentOptions = async(search?:string) => {
  var searchQuery = search !== undefined ? '?search=' + search : '';
  return httpClient.get<DataResponse<StudentOption[]>>({
    url: '/v1/students/StudentOptions' + searchQuery,
    requiresToken: true
  })
}

export const getPotentialDuplicates = async() => {  
  return httpClient.get<StudentDuplicatesResponse>({
    url: '/v1/students/Duplicates',
    requiresToken: true
  })
}

export const getManualDuplicates = async (
  studentCustomMergRequest: StudentCustomMergRequest
) => {
  return httpClient.post<StudentMergeResponse>({
    url: `/v1/students/ManualDuplicateSearch`,
    payload: studentCustomMergRequest,
    requiresToken: true,
  });
};

export const getStudent = async (studentId: number) => {
  return httpClient.get<StudentResponse>({
    url: `/v1/students/${studentId}`,
    requiresToken: true,
  });
};

export const updateStudent = async (
  studentId: number,
  studentrequest: StudentUpdateRequest
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/students/${studentId}`,
    payload: studentrequest,
    requiresToken: true,
  });
};

export const getStudentTreatments = async (studentId: number) => {
  return httpClient.get<studentTreamentResponse>({
    url: `/v1/students/treatments/${studentId}`,
    requiresToken: true,
  });
};

export const getStudentTreatmentsByCaseloadId = async (caseloadId: number) => {
  return httpClient.get<studentTreamentResponse>({
    url: `/v1/caseload/${caseloadId}/treatments`,
    requiresToken: true,
  });
};

export const getExpiresIep = async (id: number, startDays: number, endDays: number, disciplineId: number | undefined = undefined) => {
  return httpClient.get<DataResponse<Caseload[]>>({
    url: `/v1/students/expiresIep/byUser/${id}/${startDays}/${endDays}/${disciplineId}`,
    requiresToken: true,
  });
};

export const getExpires504 = async (id: number, startDays: number, endDays: number, disciplineId: number | undefined = undefined) => {
  return httpClient.get<DataResponse<Caseload[]>>({
    url: `/v1/students/expires504/byUser/${id}/${startDays}/${endDays}/${disciplineId}`,
    requiresToken: true,
  });
};

export const getStudentDisciplinesByStudentId = async (studentId: number) => {
  return httpClient.get<DataResponse<StudentDiscipline[]>>({
    url: `/v1/students/${studentId}/Disciplines`,
    requiresToken: true,
  });
};

export const getSchoolHistory = async (studentId: number) => {
  return httpClient.get<DataResponse<StudentSchoolHistory[]>>({
    url: `/v1/students/${studentId}/SchoolHistory`,
    requiresToken: true,
  });
};